(function () {
  if (window.lindenProductMobileLayoutInitialized) return;
  window.lindenProductMobileLayoutInitialized = true;

  const mobile = window.matchMedia('(max-width: 749px)');

  function updateProductLayouts() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
      const media = section.querySelector('.product__media-wrapper');
      const info = section.querySelector('.product__info-wrapper');
      const details = section.querySelector('.product__media-details');

      if (!media || !info || !details) return;

      if (mobile.matches) {
        info.insertAdjacentElement('afterend', details);
        details.style.width = '100%';
        details.style.minWidth = '0';
      } else {
        media.appendChild(details);
        details.style.removeProperty('width');
        details.style.removeProperty('min-width');
      }
    });
  }

  mobile.addEventListener('change', updateProductLayouts);
  document.addEventListener('shopify:section:load', updateProductLayouts);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateProductLayouts);
  } else {
    updateProductLayouts();
  }
})();
